/* eslint-disable no-dupe-keys */
export default {
  parking_relief: {
    name: '停车减免规则',
    // 属性（一般与对象内容匹配）
    prop: {
      charge_station: '充电站',
      parking_relief_agent: '减免服务商',
      parking_relief_type: '减免途径',
      page_url: 'URL',
      plate_number_prefix: '默认车牌前缀',
      display_mode: '页面展示方式',
      required_plate_number: '车牌传参',
      page_plate_number_param_name: 'URL车牌参数名',
      page_plate_number_js_encode_fun: 'URL车牌编码方法(JS)',
      relief_entrypoint: '减免入口',
      relief_entrypoint_preview: '页面预览',
      description: '备注',
      created_at: '创建时间',
      updated_at: '更新时间',
      dynamic_relief_code_count: '活码总数',
      available_dynamic_relief_code_count: '可用的活码数',
      dynamic_code_info: '可用/活码总数',
      dynamic_relief_code_not_enough: '活码告急',
      service_url: '服务URL',
      username: '私有云账号',
      userpwd: '私有云密码',
      free_parking_hours: '免费时长(小时)',
      auto_relief: '自动减免',
      business_id: '商家识别号',
      merchant_no: '商家编号',
      merchant_key: '商家密钥',
      park_id: '停车场ID',
      coupon_free_id: '优免模板ID',
      qr_code_url: '二维码URL',
      relief_api: '减免API',
      open_id: '微信用户OpenID',
      party_code: '场地码',
      app_id: '应用ID',
      merchant: '停车场商户号',
      store_code: '商家编号',
      coupon_code: '优惠券ID',
      app_secret: '应用密钥',
      tdzn_p_id: '减免ID',
      tdzn_key: '密钥',
      tdzn_service_url: '服务器地址',
      tdzn_parking_code: '停车场编码',
      tdzn_ticket_type: '优惠类型',
      tdzn_ticket_value: '优惠值',
      bolink_comid: '车场编号',
      bolink_ckey: '车场秘钥',
      bolink_union_id: '厂商编号',
      bolink_mitigate_type: '优惠类型',
      bolink_free_money: '减免金额',
      bolink_duration: '减免时长',
      zero_one_business_id: '停车场ID',
      zero_one_id: '优惠券ID',
      zero_one_service_url: '服务器地址',
      keytop_service_url: '服务器URL',
      keytop_app_id: '用户ID',
      keytop_app_secret: '密钥',
      keytop_park_id: '停车场ID',
      keytop_free_time: '减免停车时长',
      jie_shun_cid: '客户号',
      jie_shun_usr: '账号',
      jie_shun_psw: '密码',
      jie_shun_park_code: '车场编号',
      jie_shun_sign_key: '签名密钥',
      jie_shun_coupon_type: '优惠类型',
      jie_shun_coupon_value: '优惠值',
      jie_shun_service_url: '捷顺URL',
      energy_validation: '是否验证电量 ',
      timeout: '超时时间',
      general_free_minutes: '通用免费时间',
      script: '第三方调用脚本',
      relief_hook: '减免时间点',
      allow_scan_qr_code: '允许扫码',
      last_relieved_at: '最近减免时间',
      minimum_power: '最低电量'
    },
    // Enum的属性
    parking_relief_types: {
      relief_page: '页面',
      fixed_relief_code: '固定二维码',
      dynamic_relief_code: '二维码活码',
      relief_api: 'API'
    },
    ticket_types: {
      1: '减免金额',
      2: '减免时长',
      3: '减免百分比',
      4: '减免全额'
    },
    coupon_types: {
      0: '减免金额',
      1: '减免时间',
      2: '全免'
    },
    bolink_mitigate_types: {
      0: '全免',
      1: '时长减免',
      2: '金额减免',
      3: '停车场决定'
    },
    dynamic_relief_code_not_enoughs: {
      true: '是',
      flase: '否'
    },
    energy_validations: {
      true: '验证',
      false: '不验证'
    },
    allow_scan_qr_codes: {
      true: '允许',
      false: '不允许'
    },
    display_modes: {
      iframe: 'iframe(隐藏URL)',
      third_party_page_web: '跳转到对方页面'
    },
    parking_relief_agents: {
      jslife_h5_agent: '捷顺页面',
      jie_link_agent: '捷顺私有云',
      etcp_agent: 'ETCP',
      blue_card_soft_agent: '蓝卡',
      p_yun_agent: 'P云',
      tdznyun_agent: '腾达智能',
      bo_link_agent: '泊链',
      zero_one_agent: '0easy零壹',
      keytop_agent: '科拓',
      simple_api_agent: '简易API',
      jie_shun_agent: '捷顺',
      no_agent: '其他服务商'
    },
    relief_hooks: {
      after_order_completed: '充电结束后',
      after_general_free_minutes: '充电启动后（通用免费时间后）',
      after_idle_fee_completed: '占位结束后'
    },
    short_relief_hooks: {
      after_order_completed: '充电结束后',
      after_general_free_minutes: '充电启动后',
      after_idle_fee_completed: '占位结束后'
    },
    // Boolean的属性
    required_plate_numbers: { true: '支持', false: '不支持' },
    // 占位提示
    placeholder: {
      search_keyword: '站名/备注',
      input_page_url: '输入减免的页面URL',
      input_service_url: '输入减免的服务URL',
      input_plate_number_prefix: '输入默认车牌前缀, 如:粤C',
      input_username: '输入私有云账号',
      input_userpwd: '输入私有云密码',
      input_business_id: '输入商家识别号',
      input_merchant_no: '输入商家编号',
      input_merchant_key: '输入商家密钥',
      input_park_id: '输入停车场ID',
      input_coupon_free_id: '输入优免模板ID',
      input_open_id: '输入微信用户OpenID',
      input_party_code: '输入场地码',
      input_app_id: '输入应用ID',
      input_merchant: '输入停车场商户号',
      input_store_code: '输入商家编号',
      input_coupon_code: '输入优惠券ID',
      input_app_secret: '输入应用密钥',
      input_tdzn_p_id: '输入ID',
      input_tdzn_key: '输入密钥',
      input_tdzn_service_url: '输入服务器地址',
      input_tdzn_parking_code: '输入停车场编码',
      input_comid: '输入车场编号',
      input_ckey: '输入车场秘钥',
      input_union_id: '输入厂商编号',
      input_zero_one_business_id: '输入停车场ID',
      input_zero_one_id: '输入优惠券ID',
      input_zero_one_service_url: '输入服务器地址',
      input_keytop_service_url: '输入服务器URL',
      input_keytop_app_id: '输入用户ID',
      input_keytop_app_secret: '输入密钥',
      input_keytop_park_id: '输入停车场ID',
      input_jie_shun_cid: '输入客户号',
      input_jie_shun_usr: '输入账号',
      input_jie_shun_psw: '输入密码',
      input_jie_shun_park_code: '输入车场编号',
      input_jie_shun_sign_key: '输入签名密钥',
      input_jie_shun_service_url: '输入捷顺URL',
      input_script: '输入调用脚本'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      parking_relief_records: '减免记录',
      parking_relief_codes: '二维码活码'
    },
    group_titles: {
      base: '基本信息',
      parking_relief_agent: '减免服务商配置'
    },
    auto_reliefs: {
      true: '充电自动减免',
      false: '扫码减免'
    },
    titles: {
      gate_system: '闸机系统',
      page_preview: '页面预览'
    },
    tips: {
      energy_validation: '该功能只对绿牌生效，无论选择验证/不验证，蓝牌都需要验证电量',
      general_free_minutes: '所有车辆都可享受的免费停车时长'
    }
  }
}
